export class Proxy {
  constructor(
    public url?: string,
  ) { }
}
